// Which story the domain detail panel tells about the registrar half.
//
// A domain still transferring IN is not at our registrar yet, so NameSilo
// answers "Domain is not active, or does not belong to this user". The backend
// tags that answer `notInAccount` and returns our transfer record beside it
// (squish-backend routes/internal-domain-subs.js). Four cases, and only one of
// them is a failed lookup:
//
//   live              the registrar answered with the domain
//   transfer_pending  not ours yet, and an inbound transfer is open — expected
//   not_in_account    not ours, and no open transfer — a real problem: expired,
//                     moved away, or a transfer that never landed
//   failed            the registrar could not be asked (timeout, outage)
//
// `failed` stays the default for any unavailable read without the tag, so an
// outage on a transferring domain can never read as "not here yet".

export const TRANSFER_STAGE_LABELS = Object.freeze({
  awaiting_code: 'waiting for the customer’s transfer code',
  queued: 'code received, queued for the registrar',
  refused: 'refused by the registrar — the customer needs a new code',
  needs_attention: 'needs attention — submit outcome unconfirmed or past the transfer window',
  pending_registry: 'submitted, waiting on the registry (usually up to 5 days)',
  completed: 'completed',
  cancelled: 'cancelled',
});

export function transferStageLabel(stage) {
  return TRANSFER_STAGE_LABELS[stage] || stage || 'unknown stage';
}

// Stages where a human has to do something before the transfer moves.
export function transferNeedsAction(latest) {
  if (!latest) return false;
  return !!latest.needsHumanResolution || latest.stage === 'refused' || latest.stage === 'needs_attention';
}

export function registrarPresence(data) {
  const registrar = data && data.registrar;
  const transfer = data && data.transfer;
  if (registrar && registrar.available) return 'live';
  if (registrar && registrar.notInAccount) {
    return transfer && transfer.open ? 'transfer_pending' : 'not_in_account';
  }
  return 'failed';
}
